import {CommonModule} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';

export type BulkDeleteImpactItem = {
    label: string;
    count: number | string;
};

/**
 * Presentation-only bulk delete preview/confirm modal.
 * Parents own selection, API calls, and permission checks.
 */
@Component({
    selector: 'app-bulk-delete-preview-shell',
    imports: [CommonModule],
    templateUrl: './bulk-delete-preview-shell.component.html',
    styleUrl: './bulk-delete-preview-shell.component.css',
})
export class BulkDeletePreviewShellComponent {
    @Input() open = false;
    @Input() title = 'Confirm Bulk Delete';
    @Input() selectedLabel = 'Selected Records';
    @Input() selectedCount: number | null = null;
    @Input() willDeleteTitle = 'Records That Will Be Deleted';
    @Input() willDelete: BulkDeleteImpactItem[] = [];
    @Input() retainedTitle = 'Records That Will Be Preserved';
    @Input() relatedRetained: BulkDeleteImpactItem[] = [];
    /** Optional plain note (legacy). Prefer assurances for checklist messaging. */
    @Input() note = '';
    /** Explicit preservation / impact statements shown under the impact columns. */
    @Input() assurances: string[] = [];
    @Input() footerMessage = '';
    @Input() confirming = false;
    @Input() confirmLabel = 'Yes, Delete';

    @Output() confirm = new EventEmitter<void>();
    @Output() cancel = new EventEmitter<void>();

    onConfirm(): void {
        if (!this.confirming) {
            this.confirm.emit();
        }
    }

    onCancel(): void {
        if (!this.confirming) {
            this.cancel.emit();
        }
    }
}
